import { motion } from "framer-motion";
import { Wallet, ArrowLeftRight, Flame, Sprout } from "lucide-react";

const steps = [
  { icon: Wallet, title: "Set up a wallet", body: "Install MetaMask or any EVM wallet and secure your seed phrase." },
  { icon: ArrowLeftRight, title: "Fund with ETH (Base)", body: "Add ETH on the Base network (Base mainnet) — not Ethereum mainnet — to cover your purchase plus a little for gas fees." },
  { icon: Flame, title: "Swap for $AFTBRN", body: "Connect to the AfterBurn sale and swap ETH for $AFTBRN tokens." },
  { icon: Sprout, title: "Watch it grow", body: "3% of every trade funds real-world impact — reforestation, rebuilding, and first responders. Hold, govern, regenerate." },
];

export default function HowToBuy() {
  return (
    <section className="py-24 md:py-32 bg-card/40 border-y border-white/10">
      <div className="px-6 md:px-12 max-w-7xl mx-auto">
        <div className="max-w-2xl mb-14">
          <span className="font-mono text-xs uppercase tracking-[0.2em] text-ember">How to Contribute</span>
          <h2 className="mt-4 text-3xl sm:text-4xl lg:text-5xl font-display font-bold tracking-tight">
            Four steps to plant a forest.
          </h2>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((s, i) => (
            <motion.div
              key={s.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="bg-background border border-white/10 p-8 relative group hover:border-ember/40 transition-colors"
              data-testid={`step-${i + 1}`}
            >
              <span className="absolute top-6 right-6 font-display font-bold text-5xl text-white/5 group-hover:text-ember/20 transition-colors">
                0{i + 1}
              </span>
              <div className="w-12 h-12 border border-ember/40 flex items-center justify-center mb-6">
                <s.icon className="w-5 h-5 text-ember" />
              </div>
              <h3 className="font-display font-bold text-xl">{s.title}</h3>
              <p className="mt-3 text-muted-foreground leading-relaxed">{s.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
